/* eslint-disable camelcase */
import { createI18n } from 'vue-i18n'
import kr from '@/core/i18n/kr.json'
import en from '@/core/i18n/en.json'
import jp from '@/core/i18n/jp.json'
import zh_cn from '@/core/i18n/zh_cn.json'
import zh_hk from '@/core/i18n/zh_hk.json'
import th from '@/core/i18n/th.json'
import iconKr from '@/assets/language_icon_kr.png'
import iconEn from '@/assets/language_icon_en.png'
import iconJp from '@/assets/language_icon_jp.png'
import iconCn from '@/assets/language_icon_cn.png'
import iconTh from '@/assets/language_icon_th.png'

export const supportedLocales = [
  {
    code: 'zh_cn',
    name: 'Chinese (Simplified)',
    description: '简体中文',
    icon: iconCn
  },
  {
    code: 'zh_hk',
    name: 'Chinese (Traditional)',
    description: '繁體中文',
    icon: iconCn
  },
  {
    code: 'th',
    name: 'Thai',
    description: 'ภาษาไทย',
    icon: iconTh
  },
  {
    code: 'en',
    name: 'English',
    description: 'English',
    icon: iconEn
  },
  {
    code: 'jp',
    name: 'Japanese',
    description: '日本語',
    icon: iconJp
  },
  {
    code: 'kr',
    name: 'Korean',
    description: '한국어',
    icon: iconKr
  }
]

const i18n = createI18n({
  legacy: false,
  warnHtmlMessage: false,
  supportedLocales: supportedLocales.map(localeMap => localeMap.code),
  locale: 'en',
  messages: {
    kr,
    en,
    jp,
    zh_cn,
    zh_hk,
    th
  }
})
export default i18n
